import React from 'react';
import PropTypes from 'prop-types';
import { Spacing } from 'works/legacy/lib/style-helper';

export function AssignmentDetails({ icon, children }) {
  return (
    <article className="AssignmentDetails">
      <span className="icon">{icon}</span>
      <span className="details-body">{children}</span>
      <style jsx>{`
        .AssignmentDetails {
          display: flex;
          margin-right: ${Spacing.baseSpacingPx};
          flex-grow: 1;
        }
        .AssignmentDetails > .icon {
          margin-right: ${Spacing.baseSpacing / 2}px;
        }
      `}</style>
    </article>
  );
}

AssignmentDetails.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
};
